export default "__VITE_ASSET__Z4SJNqsI__"